"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
Object.defineProperty(exports, "__esModule", { value: true });
var React = require("react");
var reactstrap_1 = require("reactstrap");
require("../Styles/LocationSelector.css");
var Util_1 = require("../../../Services/Util");
var AuthenticationService_1 = require("../../../Services/AuthenticationService");
var Endpoints_1 = require("../../../Utils/Endpoints");
var Components_1 = require("../../../Components");
var EventHandlerService_1 = require("../../../Services/EventHandlerService");
var Types_1 = require("../../../Types");
var LocationSelectorState;
(function (LocationSelectorState) {
    LocationSelectorState[LocationSelectorState["Initial"] = 0] = "Initial";
    LocationSelectorState[LocationSelectorState["Pending"] = 1] = "Pending";
    LocationSelectorState[LocationSelectorState["Error"] = 2] = "Error";
})(LocationSelectorState || (LocationSelectorState = {}));
var LocationSelector = /** @class */ (function (_super) {
    __extends(LocationSelector, _super);
    function LocationSelector(props) {
        var _this = _super.call(this, props) || this;
        _this.handleError = function (error) {
            var eventHandler = EventHandlerService_1.EventHandlerProvider.GetInstance();
            var event = eventHandler.GetEvent();
            _this.error = error;
            event.title = _this.props.applicationData.resources.Error;
            event.actions = [
                new Types_1.VeriLiteEventAction(_this.props.applicationData.resources.Close, "secondary", function (currentEvent, closeModalCallback) {
                    closeModalCallback();
                })
            ];
            eventHandler.UpdateEvent();
            _this.setState({ state: LocationSelectorState.Error });
        };
        _this.saveOnClick = function (closeModalCallback) {
            var eventHandler = EventHandlerService_1.EventHandlerProvider.GetInstance();
            var event = eventHandler.GetEvent();
            event.title = _this.props.applicationData.resources.SetupLocations_Loading;
            event.actions = [];
            eventHandler.UpdateEvent();
            _this.setState({ state: LocationSelectorState.Pending });
            var userRequestHeaders = new Util_1.UserRequestHeaders(__assign(__assign({}, AuthenticationService_1.Auth.getUser()), { Location: _this.state.selectedLocation }));
            Util_1.getJson(Endpoints_1.default.GetAvailableActions, undefined, true, userRequestHeaders)
                .then(function (response) {
                var value = JSON.parse(response);
                _this.props.applicationData.updateCallback("availableActions", value);
                Util_1.getJson(Endpoints_1.default.GetCalibrationData, undefined, true, userRequestHeaders)
                    .then(function (response) {
                    var value = JSON.parse(response);
                    _this.props.applicationData.updateCallback("calibrationData", value);
                    _this.props.applicationData.updateCallback(AuthenticationService_1.AuthenticationService.selectedLocationKey, _this.state.selectedLocation);
                    closeModalCallback();
                }).catch(function (reason) {
                    _this.handleError("Error loading calibrationData. With reason: " + reason);
                    return;
                });
            })
                .catch(function (reason) {
                _this.handleError("Error loading availableActions. With reason: " + reason);
                return;
            });
        };
        _this.state = {
            selectedLocation: _this.props.applicationData.selectedLocation,
            state: LocationSelectorState.Initial
        };
        _this.error = "";
        return _this;
    }
    LocationSelector.prototype.render = function () {
        var _this = this;
        switch (this.state.state) {
            case LocationSelectorState.Initial:
                return (React.createElement(reactstrap_1.InputGroup, null,
                    React.createElement(reactstrap_1.InputGroupAddon, { addonType: "prepend" },
                        React.createElement(reactstrap_1.InputGroupText, null, this.props.applicationData.resources.Location)),
                    React.createElement(reactstrap_1.Input, { type: "select", name: "location", id: "locationSelect", onChange: function (e) { return _this.setState({ selectedLocation: e.target.value }); } },
                        React.createElement("option", { key: this.props.applicationData.selectedLocation, hidden: true }, this.props.applicationData.selectedLocation),
                        this.props.applicationData.locations.map(function (location) {
                            if (location.Name != _this.props.applicationData.selectedLocation) {
                                return (React.createElement("option", { key: location.Name, value: location.Name }, location.Name));
                            }
                        }))));
            case LocationSelectorState.Pending:
                return (React.createElement(Components_1.CustomSpinner, null));
            case LocationSelectorState.Error:
                return (React.createElement("div", null, this.error));
        }
    };
    return LocationSelector;
}(React.Component));
exports.LocationSelector = LocationSelector;
//# sourceMappingURL=LocationSelector.js.map